exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".execution-marker.execution-marker-running.stage-type-manualjudgment {\n  background-color: var(--color-alert);\n  fill: var(--color-alert);\n  -webkit-animation: none;\n          animation: none;\n}\n", ""]);

